import 'bootstrap';
import Fullpage from './components/fullpage';
import Offcanvas from './components/offcanvas';
import Collapse from './components/collapse';
import Modal from './components/modal';
import LazyLoading from './components/lazyloading';

Fullpage();
Offcanvas();
Collapse();
Modal();
LazyLoading();